import { useEffect } from 'react';
import { getCurrentAIScribe } from 'store/clients/clientsActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import transcribedScreenImage from 'assets/png/aiScribeBackground.png';
import { useResponsive } from 'utils/hooks/useMediaQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { AiScribeDrawer } from './drawer';
import { AiScribeModal } from './modal';
import { NewAiScribeDrawer } from './newDrawer';

const AiScribe = () => {
  const { enableMpiUpdate } = useFlags();
  const { isTablet } = useResponsive();
  const dispatch = useAppDispatch();
  const { state } = useAppSelector((s) => s.clients.aiScribe);

  useEffect(() => {
    dispatch(getCurrentAIScribe());

    // Preload transcribed screen image
    const img = new Image();
    img.src = transcribedScreenImage;
  }, []);

  if (state == null) return null;

  if (isTablet && !enableMpiUpdate) {
    return <AiScribeDrawer />;
  }

  if (isTablet && enableMpiUpdate) {
    return <NewAiScribeDrawer />;
  }

  return enableMpiUpdate ? <AiScribeModal /> : null;
};

export default AiScribe;
